import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MasterService } from 'src/app/masters/master.service';

@Component({
  selector: 'partner-search',
  templateUrl: './partner-search.component.html',
  styleUrls: ['./partner-search.component.scss']
})
export class PartnerSearchComponent implements OnInit {
  category=[];
  categoryType=[];
  countries=[];
  organisms=[];
  towns=[];
  pSearch={};
  partnerType;
  constructor(private formBuilder: FormBuilder,private masterService:MasterService) { }

  ngOnInit() {
    //this.pSearch["active"]=true;
    this.loadMasterData();
  }
loadMasterData(){
  this.masterService.getCategory().subscribe(response => {
    if (response && response['result']) {
      this.category =response['result'].filter(category => category.partnerType == this.partnerType);
    }
  })

  this.masterService.getCategoryType().subscribe(response => {
    if (response && response['result']) {
      this.categoryType  =response['result'].filter(type => type.partnerType == this.partnerType);
    }
  })

  this.masterService.getCountry().subscribe(response => {
    if (response && response['result']) {
      this.countries = response['result'];
  
    }
  })

  this.masterService.getOrganisms().subscribe(response => {
    if (response && response['result']) {
      this.organisms = response['result'];
    }
  })
  this.masterService.getTown().subscribe(response => {
    if (response && response['result']) {
      this.towns = response['result'];
    }
  })
}
}

/* get f() { return this.form.controls; }
  private getFromGroup() {
    this.form = this.formBuilder.group({
      'paCatId': new FormControl(),
      'compaVaNameEn': new FormControl(),
      'pcTypId': new FormControl(),
      'cotryId': new FormControl(),
      'city': new FormControl()
    })
  } */
